// Auto-generated translation for sl.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:40:30.007758+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Za lastnike konj",
    title: "Vse za vašega konja. V eni aplikaciji.",
    subtitle: "Upravljajte zdravje, trening, načrtovanje in strokovnjake iz enega preglednega dosjeја.",
    primaryCTA: {
      label: "Začni brezplačno",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Profil konja — teža, cepljenje, EquiCoach, prehrana in trening na enem zaslonu",
      caption: "Vaš konj, popolnoma pregledn.",
    },
    problem: "Verjetno hranite sestanke, fotografije, trening, prehrano in zdravje na različnih mestih — v skupinah WhatsApp, škatlah in ločenih aplikacijah. Zato izgubite pregled.",
    solution: "EquiSight pretvori vašega konja v en popoln digitalni dosje, ki vas spremlja povsod.",
    benefits: [
      "En popoln profil konja za vsakega konja",
      "Zdravje, kovač, zobozdravnik in fizioterapevt na enem mestu",
      "Koledar s pametnimi opomniki",
      "Fotografije, opombe in zgodovina brez omejitev",
      "Varnostna kopija vseh podatkov pri Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 konj · vedno brezplačno",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Več konj + varnostna kopija",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni za začetek?",
      title: "Začnite danes s svojim prvim konjem.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Več konj. Več pregleda. Več zanesljivosti.",
    subtitle: "Nadgradite na Premium in upravljajte vse svoje konje brez omejitev — s popolno EquiCoach inteligenco.",
    primaryCTA: {
      label: "Začnite 14 dni brezplačno",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Vse cene",
      href: "/#pricing",
    },
    audience: "Za lastnike, športne jahače in rejce konj z večimi konji.",
    features: [
      "Dodajanje neomejenega števila konj",
      "Popolna zgodovina za vsakega konja",
      "Varnostno kopiranje podatkov",
      "Poglobljeni vpogledi EquiCoach",
      "Pametna obvestila in načrtovanje",
      "Zdravje in trening popolnoma povezana",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Manj kot €0,17 na dan",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Nadgradite na Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Za jahače v jahalni šoli",
    title: "Napreduj, tudi brez lastnega konja.",
    subtitle: "Spremljaj svoje ure, treninge in razvoj znotraj EquiSight — za manj kot skodelico kave na mesec za mamo ali očeta. Ali pa za en dober sladoled s smetano.",
    primaryCTA: {
      label: "Začni s Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Kako deluje?",
      href: "#features",
    },
    problem: "Kot jahač v jahalni šoli pogosto nimaš lastnega konja, a vseeno želiš napredovati in imeti pregled nad svojimi urami, cilji in konji, na katerih jahaš.",
    solution: "Funkcionalnost jahalne šole je standardno vključena v Premium — spremljaj svoj lastni razvoj in si ogleduj povezane šolske konje v načinu samo za branje.",
    features: [
      "Beleženje treningov",
      "Postavljanje ciljev",
      "Sledenje napredku",
      "Ogled šolskih konjev z imenom in fotografijo",
      "Brez dostopa do zasebnih zdravstvenih podatkov",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Na mesec · funkcionalnost jahalne šole vključena",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Postani član",
      title: "Začni kot jahač v jahalni šoli.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Za jahalne šole in hleve",
    title: "Naredi svojo jahalnico digitalno dostopno za vsakega jahača.",
    subtitle: "Daj jahačem povezanost s konji, urami in napredkom — brez deljenja občutljivih podatkov o hlevu.",
    primaryCTA: {
      label: "Zahtevaj dostop",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si module",
      href: "#features",
    },
    audience: "EquiSight pomaga jahalnim šolam in hlevom, da jahače dlje časa ohranjajo angažirane in se digitalno razlikujejo od konkurence.",
    features: [
      "Konji jahalnice vidni jahačem",
      "Ime in fotografija za vsakega konja",
      "Povezovanje jahačev s konji",
      "Dostop samo za branje za zasebne podatke",
      "Centralizirana zgodovina ur in treningov",
      "Upravljanje uporabnikov z vlogami",
    ],
    benefits: [
      "Večja povezanost z jahači",
      "Bolj profesionalna podoba",
      "Dodatna digitalna storitev za člane",
      "Nov vir prihodkov prek uporabe aplikacije",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Na mesec · funkcionalnost jahalnice vključena za jahače",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Aktiviraj modul jahalnice.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Modul za vzrejo",
    title: "Nadzor nad ciklusom, brejostjo in razvojem žrebeta.",
    subtitle: "Popoln modul za vzrejo za lastnike kobil in rejce — od paritve do žrebeta, na eni časovnici.",
    primaryCTA: {
      label: "Aktiviraj modul za vzrejo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si funkcije",
      href: "#features",
    },
    audience: "Za rejce, lastnike kobil in hleve, ki upravljajo več kobil.",
    features: [
      "Sledenje ciklusu",
      "Beleženje pojatve",
      "Vnos datumov osemenitve",
      "Odštevalnik do ultrazvočnih pregledov",
      "Načrtovanje kontrol brejosti",
      "Rodovnik in poreklo",
      "Razvoj žrebeta",
      "Pregled vseh brejih kobil",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Na mesec · Modul za vzrejo vključen v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Začni danes",
      title: "Začni z upravljanjem vzreje.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Modul za kovača",
    title: "Delajte pametneje kot kovač. Beležite vse profesionalno.",
    subtitle: "Urnik, fotografije, opombe in zgodovina obravnav v enem modulu — manj napačnega razumevanja, močnejša dokumentacija.",
    primaryCTA: {
      label: "Začnite kot kovač",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglejte si Professional paket",
      href: "/professional",
    },
    audience: "Za kovače, ki želijo izboljšati pregled, dokazno gradivo in komunikacijo s strankami.",
    features: [
      "Lasten urnik",
      "Termini po strankah",
      "Ogled profilov konj",
      "Dodajanje fotografij pred in po",
      "Beleženje obravnave",
      "Shranjevanje nasvetov in opomb",
      "Obvestilo ETA stranki: \"Kovač je na poti\"",
    ],
    benefits: [
      "Bolj profesionalno delo",
      "Manj napačnega razumevanja",
      "Boljša gradnja dokumentacije",
      "Močnejša zaščita pri odgovornosti",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Na mesec · Modul za kovača je vključen v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Aktivirajte modul za kovača.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Modul zobozdravnik",
    title: "Popolna zobozdravstvena dokumentacija za vsakega konja.",
    subtitle: "Beležite ugotovitve, zdravljenja in nadaljnje ukrepe neposredno v EquiSight.",
    primaryCTA: {
      label: "Začnite kot konjski zobozdravnik",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglejte si Professional paket",
      href: "/professional",
    },
    audience: "Konjski zobozdravniki, veterinarji in prakse, ki želijo delati strukturirano.",
    features: [
      "Evidentiranje pregleda zob",
      "Ugotovitve po posameznem zdravljenju",
      "Dodajanje fotografij",
      "Poročanje lastniku",
      "Priporočila za nadaljnje ukrepanje",
      "Zgodovina za vsakega konja",
      "Načrtovanje novega termina",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Na mesec · Modul zobozdravnik vključen v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Aktivirajte modul zobozdravnik.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fizioterapija / Osteopatija modul",
    title: "Strokovno spremljajte telo, gibanje in okrevanje.",
    subtitle: "Za fizioterapevte in osteopate, ki želijo konje sistematično voditi.",
    primaryCTA: {
      label: "Začni kot fizioterapevt/osteopat",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si Professional paket",
      href: "/professional",
    },
    features: [
      "Vnos podatkov za posameznega konja",
      "Beleženje telesnih ugotovitev",
      "Dodajanje fotografij in videoposnetkov",
      "Ustvarjanje poročila o zdravljenju",
      "Deljenje vaj in nadaljnjega vodenja",
      "Sledenje poteku okrevanja",
      "Zgodovina za posameznega konja",
    ],
    benefits: [
      "Boljši vpogled skozi čas",
      "Profesionalno poročanje",
      "Jasna komunikacija z lastnikom, trenerjem in jahačem",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Na mesec · Fizioterapija / Osteopatija modul vključen v Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Aktivirajte modul Fizioterapija / Osteopatija.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Modul za trenerje",
    title: "Trenirajte jahače s podatki, cilji in napredkom.",
    subtitle: "Naredite trening merljiv in vodenje bolj profesionalno — za enega ali več jahačev.",
    primaryCTA: {
      label: "Začni kot trener",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si Pro paket",
      href: "/#pricing",
    },
    audience: "Za inštruktorje, trenerje in coache z več jahači ali konji.",
    features: [
      "Poveži jahače",
      "Sledi konjem",
      "Nastavi cilje treninga",
      "Daj povratne informacije",
      "Analiziraj rezultate tekmovanj",
      "Oglej si napredek po kombinaciji",
      "Uporabi analizo protokolov za fokus treninga",
    ],
    benefits: [
      "Boljše vodenje",
      "Več strukture",
      "Bolj profesionalna komunikacija",
      "Večja navezanost s strankami",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Na mesec · Modul za trenerje vključen v Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Aktivirajte modul za trenerje.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Analiza tekmovanj",
    title: "Od protokola do izboljšanja nastopa.",
    subtitle: "Naloži svoj tekmovalni protokol in odkrij, kje izgubljaš točke — ne le oglej si rezultat, ampak razumi, kako napredovati.",
    primaryCTA: {
      label: "Analiziraj svoj prvi protokol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglej si Premium",
      href: "/premium",
    },
    features: [
      "Nalaganje fotografije protokola",
      "Obdelava sprednje in zadnje strani",
      "Prepoznavanje razreda, številke preizkušnje in sodnika",
      "Analiza ocen po posameznih elementih",
      "Povzetek komentarjev",
      "Prikaz prednosti in slabosti",
      "Trendi po kombinaciji konj–jezdec",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Na mesec · analiza tekmovanj vključena od Premium naprej",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Začnite z analizo tekmovanj.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional paket",
    title: "Za strokovnjake, ki delajo s konji.",
    subtitle: "Kovač, zobozdravnik, fizioterapevt, osteopat ali trener: sodelujte v enem digitalnem konjskem dosjeju.",
    primaryCTA: {
      label: "Začnite kot strokovnjak",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Oglejte si posamezne module",
      href: "#features",
    },
    audience: "Paket Professional združuje vse strokovne module v enem naročniškem paketu.",
    features: [
      "Modul za kovača",
      "Modul za zobozdravnika",
      "Modul za fizioterapevta / osteopata",
      "Koledar in upravljanje strank",
      "Profili konj in poročila",
      "Zgodovina zdravljenja in gradnja dosjejev",
      "Komunikacija z lastnikom",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Na mesec · vsi strokovni moduli vključeni",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Pripravljeni?",
      title: "Izberite Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Nujne številke za konja",
    title: "Vedno prava pomoč na dosegu roke.",
    subtitle: "V sili šteje vsaka sekunda. Z EquiSight imate vse pomembne kontaktne podatke vašega konja takoj pri roki — en dotik in že kličete.",
    primaryCTA: {
      label: "Pripravite svoje nujne kontakte",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Začnite brezplačno z EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Nujni kontakti — neposredno klicanje, pošiljanje sporočil WhatsApp ali navigacija do veterinarja, klinike in kovača",
      caption: "En dotik. Brez panike.",
      embeddedFrame: true,
    },
    problem: "Vaš konj ima težave — kolika, poškodba, panika. In potem se začne iskanje. Koga pokličete? Imate pravo številko? Je to nujnostna številka? Izgubi se dragoceni čas.",
    solution: "Z EquiSight imate vse takoj pri roki. Brez iskanja. Brez dvomov. En dotik in vzpostavite stik.",
    scenario: {
      title: "Predstavljajte si — vaš konj kaže znake kolike.",
      steps: [
        "Odprete EquiSight",
        "Kliknete na \"Veterinar\"",
        "Neposredno pokličete",
      ],
      tagline: "Brez stresa. Brez iskanja. Le ukrepanje.",
    },
    features: [
      "Vse nujne številke na enem mestu",
      "Klicanje z enim dotikom iz aplikacije",
      "Pošiljanje sporočil WhatsApp z enim dotikom",
      "Neposredna navigacija do naslova",
      "Lastni seznam kontaktov za vsakega konja",
      "Veterinar, klinika, kovač, zobozdravnik, fizioterapevt",
      "Naslov in navodila za pot takoj na voljo",
      "Označite priljubljene številke z zvezdico",
      "Nujne številke (112, 144) vedno na vrhu",
    ],
    benefits: [
      "Mir in nadzor v nujni situaciji",
      "Vsi v hlevu imajo enake številke pri roki",
      "Konec pozabljenih vizitk",
      "Reagirajte sekunde hitreje v sili",
    ],
    audience: "Za lastnike konj, oskrbnike, trenerje in hleve — vsakogar, ki je odgovoren za konja.",
    showcase: {
      eyebrow: "Vnaprej pripravljeno za vas",
      title: "13 kategorij kontaktov — pripravljenih za izpolnitev.",
      description: "Od veterinarja in urgentne klinike do sedlarja, inštruktorja in upravljavca pašnika. EquiSight pozna vaš svet in vnaprej pripravi prava kontaktna polja za vas. Tapnite, izpolnite, končano.",
      bullets: [
        "Nujnost in zdravje — veterinar, nujna pomoč, klinika, linija za zastrupitve",
        "Dnevna nega — kovač, zobozdravnik, fizioterapevt, inštruktor",
        "Hlev in pašnik — hlevar, upravljavec pašnika, penzionirani hlev",
        "Krma in material — dobavitelji sena, močne krme, slame",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Zaslon za upravljanje nujnih kontaktov — vsi predlagani kontakti po kategorijah",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Kontrolni seznam nujnih številk za konja",
      items: [
        "Veterinar",
        "Urgentna klinika (24/7)",
        "Živalska reševalna služba · 144",
        "Kovač",
        "Nadomestna kontaktna oseba",
        "Splošna alarmna številka · 112",
      ],
      cta: {
        label: "Odprite v EquiSight in takoj izpolnite",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Nujne številke",
          price: "Gratis",
          note: "Vedno brezplačno · za vse, v vsakem naročniškem paketu",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Poskrbite, da ste pripravljeni",
      title: "Preden bo to potrebno.",
      href: "/#waitlist",
    },
    microcopy: [
      "Brez obveznosti",
      "Nastavljeno v 2 minutah",
      "Kadarkoli prilagodljivo",
    ],
  },
};

export default LANDINGS;
